export const availableLanguages = ['de', 'en'];
export const defaultLanguage = availableLanguages[0];

export interface Settings {
  key: string;
  value: string;
}

export interface RouteSettings {
  carParkingTimeInMinutes: number;
  bikeParkingTimeInMinutes: number;
  maximumTourLengthInHours: number;
  timePerLeadInMinutes: number;
}
